import _ from 'lodash'
import { lazy } from 'react'
import { IRouteItem } from '@ud/admin-framework'
import { buildCacheRoute } from '../utils'


/** 权限管理 */
const authority: IRouteItem[] = [
  { // 角色管理
    path: '/uaa/authority/role/list',
    customId: '_uaa_authority_role_list',
    component: lazy(() => import('../pages/uaa/authority/role/RoleList'))
  },
  { // 角色详情
    path: '/uaa/authority/role/detail/:id',
    customId: '_uaa_authority_role_list_view',
    component: lazy(() => import('../pages/uaa/authority/role/RoleDetail'))
  },
  { // 角色编辑
    path: '/uaa/authority/role/edit/:id',
    customId: '_uaa_authority_role_list_addOrUpdate',
    component: lazy(() => import('../pages/uaa/authority/role/RoleEdit'))
  },
  { // 角色下的用户列表
    path: '/uaa/authority/role/:id/users',
    customId: '_uaa_authority_role_list_getUserVOByRole',
    component: lazy(() => import('../pages/uaa/authority/role/UserList'))
  },
  { // 角色下的岗位列表
    path: '/uaa/authority/role/:id/jobs',
    customId: '_uaa_authority_role_list_getPostTypeVOByRole',
    component: lazy(() => import('../pages/uaa/authority/role/JobsList'))
  },

  { // 用户管理
    path: '/uaa/authority/user/list',
    customId: '_uaa_authority_user_list',
    component: lazy(() => import('../pages/uaa/authority/user/UserList'))
  },
  { // 用户管理新增
    path: '/uaa/authority/user/add',
    customId: '_uaa_authority_user_list_saveOrUpdateUser',
    component: lazy(() => import('../pages/uaa/authority/user/UserInfoSetting'))
  },
  { // 用户管理编辑
    path: '/uaa/authority/user/edit/:id',
    customId: '_uaa_authority_user_list_getUserById',
    component: lazy(() => import('../pages/uaa/authority/user/UserInfoSetting'))
  },

  { // 菜单管理
    path: '/uaa/authority/menu-manage',
    customId: '_uaa_authority_authorization_list',
    component: lazy(() => import('../pages/uaa/authority/menu'))
  },

  { // 授权跟踪
    path: '/uaa/authority/tracking/list',
    customId: 'M_AUTH_TRACK',
    component: lazy(() => import('../pages/uaa/authority/tracking/AuthorizationTracking'))
  },

  { // 自然个体类型
    path: '/uaa/authority/natural-unit/NaturalUnitTypeList',
    customId: 'M_NATURAL_UNIT_TYPE_LIST',
    component: lazy(() => import('../pages/uaa/authority/natural-unit/NaturalUnitTypeList'))
  },

  { // 自然个体
    path: '/uaa/authority/natural-unit/NaturalUnitList',
    customId: 'M_NATURAL_UNIT_LIST',
    component: lazy(() => import('../pages/uaa/authority/natural-unit/NaturalUnitList'))
  },
  { // 用户管理编辑
    path: '/uaa/authority/natural-unit/limit/:id',
   /// customId: '_uaa_authority_user_list_getUserById', //做限制
    component: lazy(() => import('../pages/uaa/authority/natural-unit/limit'))
  },

  { // 登录渠道
    path: '/uaa/authority/login-channel/List',
    customId: 'M_LOGIN_CHANNEL_LIST',
    component: lazy(() => import('../pages/uaa/authority/login-channel/List'))
  },

]

/** 日志记录 */
const log: IRouteItem[] = [
  // 敏感日志 列表
  buildCacheRoute({
    path: '/uaa/log/opt/list',
    customId: '_uaa_log_opt_list',
    component: lazy(() => import('../pages/uaa/log/opt/List'))
  }),
  {
    path: '/uaa/log/opt/detail/:id',
    customId: '_uaa_log_opt_list_detail',
    component: lazy(() => import('../pages/uaa/log/opt/Details'))
  },

  // API日志 列表
  buildCacheRoute({
    path: '/uaa/log/api/list',
    customId: '_uaa_log_api_list',
    component: lazy(() => import('../pages/uaa/log/api/List'))
  }),
  {
    path: '/uaa/log/api/detail/:id',
    customId: '_uaa_log_api_list_detail',
    component: lazy(() => import('../pages/uaa/log/api/Details'))
  },

  // 访问日志 列表
  buildCacheRoute({
    path: '/uaa/log/access/list',
    customId: '_uaa_log_access_list',
    component: lazy(() => import('../pages/uaa/log/access/List'))
  }),
  {
    path: '/uaa/log/access/detail/:id',
    customId: '_uaa_log_access_list_detail',
    component: lazy(() => import('../pages/uaa/log/access/Details'))
  },

  // 操作日志 列表
  buildCacheRoute({
    path: '/uaa/log/operate/list',
    customId: '_uaa_log_operate_list',
    component: lazy(() => import('../pages/uaa/log/operate/List'))
  }),
  {
    path: '/uaa/log/operate/detail/:id',
    customId: '_uaa_log_operate_list_detail',
    component: lazy(() => import('../pages/uaa/log/operate/Details'))
  },

  // 异常日志 列表
  buildCacheRoute({
    path: '/uaa/log/exception/list',
    customId: '_uaa_log_exception_list',
    component: lazy(() => import('../pages/uaa/log/exception/List'))
  }),
  {
    path: '/uaa/log/exception/detail/:id',
    customId: '_uaa_log_exception_list_detail',
    component: lazy(() => import('../pages/uaa/log/exception/Details'))
  },
]

/** 平台中心 */
const platform: IRouteItem[] = [
  { // 平台管理
    path: '/uaa/platform/app/list',
    customId: '_uaa_platform_app_list',
    component: lazy(() => import('../pages/uaa/platform/AppList'))
  },
]

/** 组织架构 */
const org: IRouteItem[] = [
  { // 组织架构列表
    path: '/uaa/org/organization/list',
    customId: 'M_AUTH_UNIT_TREE',
    component: lazy(() => import('../pages/uaa/org/organization'))
  },
  { // 组织架构列表
    path: '/uaa/org/organizationShow/list',
    customId: "M_ORG_UNIT_VIEW_LIST",
    component: lazy(() => import('../pages/uaa/org/organizationShow'))
  },
  { // 纬度管理
    path: '/uaa/org/organization/dimensions/list',
    customId: 'M_ORG_DIMENSION_LIST',
    component: lazy(() => import('../pages/uaa/org/organization/DimensionsManage'))
  },

  { // 员工管理
    path: '/uaa/org/employee/list',
    customId: 'M_AUTH_EMPLOYEE_LIST',
    component: lazy(() => import('../pages/uaa/org/employee/List'))
  },
  { // 员工编辑
    path: '/uaa/org/employee/edit/:id',
    customId: 'R_AUTH_EMPLOYEE_UPDATE',
    component: lazy(() => import('../pages/uaa/org/employee/Edit'))
  },

  { // GEO管理
    path: '/uaa/org/geo',
    customId: 'M_AUTH_GEO_TREE',
    component: lazy(() => import('../pages/uaa/org/geo'))
  },

  { // 岗位类型管理
    path: '/uaa/org/job/list',
    customId: 'M_AUTH_POST_TYPE_LIST',
    component: lazy(() => import('../pages/uaa/org/job/List'))
  },
  { // GEO渠道管理
    path: '/uaa/org/manage',
    customId: 'M_AUTH_GEO_CHANNEL_QUERY',
    component: lazy(() => import('../pages/uaa/org/manage'))
  },
  { // 员工分组管理
    path: '/uaa/org/employee/group',
    customId: 'M_AUTH_EMPLOYEE_GROUP_LIST',
    component: lazy(() => import('../pages/uaa/org/employeeGroup'))
  },
  { // 岗位类型分组管理
    path: '/uaa/org/employee/job/group',
    customId: 'M_AUTH_POST_TYPE_GROUP_LIST',
    component: lazy(() => import('../pages/uaa/org/jobGroup'))
  }
]

/** 运维管理 */
const operations: IRouteItem[] = [
  { // 组织架构列表
    path: '/uaa/operations/maven/list',
    customId: 'M_MAVEN_TRACK',
    component: lazy(() => import('../pages/uaa/operations/maven/MavenRelyList'))
  },
  { // 命名空间
    path: '/uaa/extension/name-spaces-list',
    customId: 'M_NAMESPACE',
    component: lazy(() => import('../pages/uaa/extension/NameSpacesList'))
  },
  { // 扩展命名空间
    path: '/uaa/extension/add/:code',
    customId: 'R_NAMESPACE_EDIT',
    component: lazy(() => import('../pages/uaa/extension/NameSpacesAdd'))
  },
]

/** 集成管理 */
const integration: IRouteItem[] = [
  { // 外部用户列表
    path: '/uaa/integration/external-user/list',
    customId: 'M_EXTERNAL_USER_LIST',
    component: lazy(() => import('../pages/uaa/integration/external-user/List'))
  },
]

const uaaRoutes: IRouteItem[] = [
  ...authority,
  ...log,
  ...platform,
  ...org,
  ...operations,
  ...integration
]

export { uaaRoutes }
